/**
 * Created by rak on 11/12/2014.
 */
(function() {
  'use strict';

  angular
    .module('betosyswebapp')
    .controller('LogoutController', LogoutController);

  /** @ngInject */
  function LogoutController(AuthenticationService, dataContainerService, messageService, $state) {
    AuthenticationService.logout().finally(function () {
      dataContainerService.cleanAllCache();
      messageService.deInitialize();
      $state.go('home');
    });
  }
})();



// WEBPACK FOOTER //
// ./.tmp/components/login/logoutController.js